import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import GenericDialog from './GenericDialog';

class ReloadDialog extends Component {
  render() {
    const { t, open, onReloadEverything, onReloadAddresses, onClose } = this.props;
    const title = t('dialogs.reload.title');
    const message = t('dialogs.reload.message');
    const buttons = [
      { text: t('buttons.cancel'), onClick: onClose },
      { text: t('buttons.reloadEverything'), onClick: onReloadEverything },
      { text: t('buttons.reloadAddresses'), onClick: onReloadAddresses },
    ];
    return (
      <GenericDialog open={open} onClose={onClose} title={title} buttons={buttons}>
        {message}
      </GenericDialog>
    );
  }
}

ReloadDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onReloadEverything: PropTypes.func.isRequired,
  onReloadAddresses: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withNamespaces()(ReloadDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/ReloadDialog.js